import React, { useState, useEffect, useRef } from 'react';
import { AutoComplete, Form, Input, Table, ConfigProvider, Button, Space, Modal, Typography, message, Tag, Tooltip } from 'antd';
import { SearchOutlined, TransactionOutlined, RedEnvelopeOutlined, BoldOutlined, VerifiedOutlined } from '@ant-design/icons';
import { request } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const { Paragraph, Text } = Typography;
const Hdgtz = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [form] = Form.useForm();
  const [formdrz] = Form.useForm();

  const [open, setOpen] = useState(false);
  const [opendrz, setOpendrz] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [list, setList] = useState([]);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [titnr, settitnr] = useState();// 选择的产品信息
  const [ticks, setticks] = useState([]);
  const [yhname, setYhname] = useState([]);//检索的银行名称

  useEffect(() => {
    async function getau() {
      const resb = await request.post('/p_bank')
      setbangm(resb.rescode)
      const res = await request.post('/hdgtz_list')
      setList(res.rescode)
    }
    getau()
  }, [ticks])

  const gohf = (v, b) => {
    setccpxx(v)
    b === "cs" && settitnr("认证次数")
    b === "sq" && settitnr("胜券余额")
    b === "yx" && settitnr("营销余额")
    b === "ye" && settitnr("账户余额")
    formxf.setFieldsValue({ dbno: v.key, dw: b, valu: '' });
    setOpen(true)
  }
  // 
  const godrz = (e) => { 
    setOpendrz(true)
    formdrz.setFieldsValue({ userno: e.key, userid: e.userid });
  }

  // 

  const onFinishdrz = async (value) => {
    setOpendrz(false)
    const rzs = await request.post('/a_drz', value)
    if (rzs.return_code === 'success' && rzs.respCode === '00000000') {

      messageApi.open({
        type: 'success',
        content: rzs.return_msg,
      })
      setOpendrz(false)
      setticks(rzs.ticks)

    } else {

      messageApi.open({
        type: 'error',
        content: rzs.return_code === "error" ? rzs.return_msg : rzs.return_msg
      })
      setOpendrz(false)
    }

  };
  // 验证


  // 
  const yhnameSearch = (value) => {
    setYhname(() => {
      if (!value) { return []; } else {

        return bangm.filter((b) => { return b.bankname.indexOf(value) > -1 });


      }

    });
  };

  // 


  const onFxfsq = async (e) => {
    const rq = await request.post('/hdgtz', e)
    setOpen(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }







  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [
    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title={`钱包余额：${record.qbje}`} color='geekblue'><Tag color="green" onClick={() => gohf(record, 'ye')}><TransactionOutlined />余额</Tag></Tooltip>
          {false && <Tooltip title={`营销余额：${record.yxye}`} color='geekblue'><Tag color="cyan" onClick={() => gohf(record, 'yx')}><RedEnvelopeOutlined />营销</Tag></Tooltip>}
          <Tooltip title={`胜券余额：${record.dqye}`} color='geekblue'><Tag color="blue" onClick={() => gohf(record, 'sq')}><BoldOutlined />胜券</Tag></Tooltip>
          <Tooltip title={`认证剩余次数：${record.rzn}`} color='geekblue'><Tag color="purple" onClick={() => gohf(record, 'cs')}><VerifiedOutlined />次数</Tag></Tooltip>

          <Tag color="#237804" onClick={() => godrz(record)}><VerifiedOutlined />代</Tag>
        </Space>
      ),
    },
    {
      title: '用户编号',
      dataIndex: 'userid',
      key: 'userid',
      ...getColumnSearchProps('userid'),
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
      render: (_, record) => (

        <Tooltip title={record.key} color='geekblue'>
          <span>{record.userid}</span>
        </Tooltip>
      ),
    },

    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
      ...getColumnSearchProps('username'),
      render: (_, record) => (

        <Tooltip title={`数据量：${record.hznum}`} color='geekblue'>
          <span>{record.username}</span>
        </Tooltip>
      ),
    },
    {
      title: '到期时间',
      key: 'dqtime',
      ...getColumnSearchProps('dqtime'),
      dataIndex: 'dqtime',
      render: (_, record) => (

        <Tooltip title={`注册时间：${record.zctime}`} color='geekblue'>
          <span>{record.dqtime}</span>
        </Tooltip>
      ),
    },
    {
      title: '营销余额',
      key: 'yxye',
      dataIndex: 'yxye',
    },
    {
      title: '推广收益',
      key: 'tgsy',
      dataIndex: 'tgsy',
    },
  ];


  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <div >
          <Form form={form} component={false}>

            <Table columns={columns} dataSource={list} size="small" />

          </Form>



        </div>


        <Modal
          // title="数据修复申请表"
          footer={null}
          centered
          open={open}
          onOk={() => onFxfsq()}
          onCancel={() => setOpen(false)}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          <Paragraph> 数据编号：{ccpxx.userid} <Text>用户名：{ccpxx.username}</Text> </Paragraph>

          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >

            <Form.Item name='dbno'
              hidden={true}
            >
              <Input />
            </Form.Item>
            <Form.Item name='dw'
              hidden={true}
            >
              <Input />
            </Form.Item>



            <Form.Item label={titnr} name='valu' rules={[{ required: true, message: '填写对应数字！' },]}>
              <Input />
            </Form.Item>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                block={true} >
                提          交
              </Button>
            </Form.Item>


          </Form>
        </Modal>

        {/* drzs */}
        <Modal
          title="企业认证信息"
          centered
          open={opendrz}
          footer={null}

          onCancel={() => setOpendrz(false)}
          width={800}
        >


          <Form
            form={formdrz}
            labelCol={{
              flex: '110px',
            }}
            labelAlign="left"
            labelWrap
            wrapperCol={{
              flex: 1,
            }}
            colon={false}
            style={{
              maxWidth: 600,
            }}
            onFinish={onFinishdrz}
          >

            <Form.Item
              name="userno" key="userno"
              hidden={true}
            >
              <Input />
            </Form.Item>
            <Form.Item

              name="userid" key="userid"
              hidden={true}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="企业名称"
              name="qname" key="qname"
              rules={[
                {
                  required: true, message: '请填写正确公司名称！'
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="统一信用代码"
              name="xydm" key="xydm"
              rules={[
                {
                  required: true, message: '请填写公司统一信用代码！'
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="法人名称"
              name="fname" key="fname"
              rules={[
                {
                  required: true, message: '请填写法人名字！'
                },
              ]}
            >
              <Input />
            </Form.Item>
          
            <Tooltip title="输入开户银行全称即可，无需输入分行、支行" color='#2db7f5' key='ts0058' >
              <Form.Item  label="开户行" name="bankname" key="bankname" rules={[{ required: true, message: '请选择公司账户开户行！' },
              ]} >
                <AutoComplete  onSearch={yhnameSearch} options={yhname} />
              </Form.Item>
            </Tooltip>

            <Form.Item
              label="对公账号"
              name="gnum" key="gnum"
              rules={[
                {
                  required: true, message: '请填写正确的公司账户！'
                },
              ]}
            >
              <Input style={{
                width: '100%',
                alignContent: 'left'
              }}
              />
            </Form.Item>


            <Tooltip title="联行号，个别商业银行需要填写" color='#2db7f5' key='ts0058' >
              <Form.Item  label="联行号" name="subbank" key="subbank"  >
              <Input />
              </Form.Item>
            </Tooltip>
       

            <Form.Item label=" " key='tsubbutton'>
              <Button type="primary" block={true} htmlType="submit">
                提交
              </Button>
            </Form.Item>
          </Form>



        </Modal>
        {/* drze */}

      </ConfigProvider>
    </>

  );
};
export default Hdgtz;